import { useContext } from 'react';
import { Button, Container, Group, Text, Title } from '@mantine/core';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '@contexts/auth-context';
import { getBillingAccessMessage } from '@services/billing-access';

function BillingAccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isLoading, isAuthenticated, signOut } = useContext(AuthContext);

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const reason = searchParams.get('reason') || undefined;
  const message = getBillingAccessMessage(reason);

  return (
    <Container size="sm" py="xl">
      <Title order={2} ta="center">
        {message.title}
      </Title>
      <Text c="dimmed" size="md" ta="center" mt="md">
        {message.body}
      </Text>
      <Group justify="center" mt="xl">
        <Button onClick={() => navigate('/billing')}>{message.ctaLabel}</Button>
        <Button color="red" variant="light" onClick={signOut}>
          Logout
        </Button>
      </Group>
    </Container>
  );
}

export default BillingAccessPage;
